export function setSavedData(availableTiles, savedTileLayout, columns) {
    const tiles = [];
    const removedTiles = [];
    const unavailableTiles = [];

    for (let i = 0; i < availableTiles.length; i++) {
        let item = availableTiles[i];
        item.isAvailable = item.isAvailable || function () {
            return true;
        };
        let saveData = savedTileLayout[item.tileId];
        if (saveData == null) {
            item.visible = item.isAvailable();
            item.colSpan = Math.min(item.colSpan, columns);
            tiles.push(item);
            continue;
        }

        let columnData = saveData.columns[columns];
        if (!columnData && saveData.columns[6]) {
            columnData = saveData.columns[6];
            columnData.colSpan = Math.ceil(columns * (columnData.colSpan / 6)) || 1;
        }
        if (columns != null) {
            item.colSpan = columnData?.colSpan || 1;
            item.rowSpan = columnData?.rowSpan || 1;
        } else {
            item.colSpan = Math.min(item.colSpan, columns);
        }
        item.sortOrder = saveData.sortOrder;
        item.visible = saveData.visible;

        if (item.visible) tiles.push(item);
        else if (item.isAvailable()) removedTiles.push(item);
        else unavailableTiles.push(item);
    }

    return { tiles, removedTiles, unavailableTiles };
}
